import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

import ErrorImage from './images/error.png';
import { constants } from '../../constants';
import { t } from '../../services/translation/translation';

export const ErrorPage = () => {
  return (
    <section className="h-[calc(100vh_-_3rem)] bg-background font-serif flex flex-col justify-center mx-5">
      <Helmet>
        <title>{t('error.head-title')}</title>
      </Helmet>
      <div className="flex justify-center xl:h-2/3">
        <div className="w-full">
          <img className="w-auto max-h-48 m-auto" alt="error" src={ErrorImage} />
          <h3 className="mt-8 text-5xl text-center">{t('error.lost')}</h3>
          <p className="text-center text-xl xl:text-2xl m-8">{t('error.not-found')}</p>
          <div className="flex justify-center mt-4">
            <Link
              to={constants.legacyWebappHost}
              className="text-2xl xl:text-4xl w-3/4 xl:w-1/2 px-4 py-2 border-2 border-success bg-success text-text_light hover:text-success hover:bg-background text-center"
            >
              {t('error.button')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
